import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
// React-table library requires to import css as well:
import ReactTable from 'react-table';
import 'react-table/react-table.css'; // eslint-disable-next-line
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import HighlightOff from '@material-ui/icons/HighlightOff';
import { mesi, orariControlli } from '../../../../utils/constants.js';

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '190px',
      // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 270,
    },
  },
};

const styles = (theme) => ({
  formcontrol: {
    marginBottom: '30px',
    width: '270px',
    padding: '0px 4px',
  },
  container: {
    //maxWidth: "800px",
    padding: '0px 0px 20px 0px',
  },
  addButton: {
    color: theme.palette.text.main,
    margin: '10px',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  tableContainer: {
    margin: '10px 0px 10px 0px',
    paddingBottom: '10px',
  },
});

class FormAnnuale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cadenza: {
        orario: '08:00:00',
        giornoSettimana: null,
        mese: 'JANUARY',
        giornoMese: 1,
        schedaId: null,
        id: null,
        controlloConformitaId: null,
      },
    };
  }
  onSelect = (event) => {
    this.handleChange(event.target.name, event.target.value);
  };
  /*
30 giorni ha novembre 
con aprile, giugno e settembre 
Di 28 ce ne è uno
Tutti gli altri son 31
*/
  getDaysInMonth = (month) => {
    switch (month) {
      case 'FEBRUARY':
        return 28;
      case 'APRIL':
      case 'JUNE':
      case 'SEPTEMBER':
      case 'NOVEMBER':
        return 30;
      default:
        return 31;
    }
  };
  handleChange = (name, value) => {
    let cadenza = JSON.parse(JSON.stringify(this.state.cadenza));

    if (name === 'mese') {
      const daysInNewMonth = this.getDaysInMonth(value);
      if (cadenza.giornoMese > daysInNewMonth) {
        cadenza.giornoMese = daysInNewMonth;
      }
    }

    cadenza[name] = value;

    this.setState({
      cadenza,
    });
  };
  getGiorniMese = (mese) => {
    switch (mese) {
      case 'FEBRUARY':
        return Array.from({ length: 28 }, (_, i) => i + 1);
      case 'APRIL':
      case 'JUNE':
      case 'SEPTEMBER':
      case 'NOVEMBER':
        return Array.from({ length: 30 }, (_, i) => i + 1);
      default:
        return Array.from({ length: 31 }, (_, i) => i + 1);
    }
  };
  render() {
    const giorniControlli = this.getGiorniMese(this.state.cadenza.mese);
    const { classes } = this.props;

    const columns = [
      {
        Header: 'ID',
        id: 'id',
        accessor: (d) => d.id,
        show: false,
      },
      {
        Header: 'Orario',
        id: 'orario',
        accessor: (d) => d.orario,
        minWidth: 104,
      },
      {
        Header: 'Giorno Mese',
        id: 'giornoMese',
        accessor: (d) => d.giornoMese,
        minWidth: 104,
      },
      {
        Header: 'Mese',
        id: 'mese',
        accessor: (d) => d.mese,
        minWidth: 104,
        Cell: (props) => {
          if (props.value !== null) {
            switch (props.value) {
              case 'JANUARY':
                return 'GENNAIO';
              case 'FEBRUARY':
                return 'FEBBRAIO';
              case 'MARCH':
                return 'MARZO';
              case 'APRIL':
                return 'APRILE';
              case 'MAY':
                return 'MAGGIO';
              case 'JUNE':
                return 'GIUGNO';
              case 'JULY':
                return 'LUGLIO';
              case 'AUGUST':
                return 'AGOSTO';
              case 'SEPTEMBER':
                return 'SETTEMBRE';
              case 'OCTOBER':
                return 'OTTOBRE';
              case 'NOVEMBER':
                return 'NOVEMBRE';
              case 'DECEMBER':
                return 'DICEMBRE';
              default:
                return '-';
            }
          }
          return '-';
        },
      },
      {
        id: 'eliminaBtn',
        Header: 'Elimina',
        accessor: (row) => row,
        width: 90,
        Cell: (props) => (
          <IconButton
            size="small"
            disabled={false}
            onClick={() => {
              this.props.onDeleteCadenza(props.index);
            }}
            color="primary"
            title="Rimuovi cadenza"
          >
            <HighlightOff />
          </IconButton>
        ),
      },
    ];

    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.container}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography variant="body1" style={{ fontWeight: 500 }} gutterBottom>
            Giorno del mese e orari del controllo
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <Grid container justify="center">
            <FormControl className={classes.formcontrol}>
              <InputLabel id="giornoNotifica-label">
                Mese del controllo
              </InputLabel>
              <Select
                labelId="giornoNotifica-label"
                value={this.state.cadenza.mese}
                name="mese"
                onChange={this.onSelect}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value={''}>
                  <em>Seleziona un mese</em>
                </MenuItem>
                {mesi.map((mese) => (
                  <MenuItem key={mese.value} value={mese.value}>
                    {mese.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className={classes.formcontrol}>
              <InputLabel id="giornoMese-label">Giorno del mese</InputLabel>
              <Select
                labelId="giornoMese-label"
                value={this.state.cadenza.giornoMese}
                name="giornoMese"
                onChange={this.onSelect}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value={0}>
                  <em>Seleziona il giorno</em>
                </MenuItem>
                {giorniControlli.map((giornomese) => (
                  <MenuItem key={giornomese} value={giornomese}>
                    {giornomese}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className={classes.formcontrol}>
              <InputLabel id="orario-label">Ora del controllo</InputLabel>
              <Select
                labelId="orario-label"
                value={this.state.cadenza.orario}
                name="orario"
                onChange={this.onSelect}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value={''}>
                  <em>Seleziona un orario</em>
                </MenuItem>
                {orariControlli.map((orario) => (
                  <MenuItem key={orario.value} value={orario.value}>
                    {orario.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className={classes.formcontrol}>
              <Button
                size="small"
                onClick={() => this.props.onAddCadenza(this.state.cadenza)}
                variant="contained"
                disabled={false}
                className={classes.addButton}
              >
                Aggiungi
              </Button>
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.tableContainer}
        >
          <ReactTable
            filterable={false}
            resizable={true}
            showPageSizeOptions={true}
            showPageJump={true}
            defaultPageSize={5}
            style={{
              height: 300,
              width: '100%',
            }}
            data={this.props.cadenze}
            columns={columns}
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun record"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
          />
        </Grid>
      </Grid>
    );
  }
}

FormAnnuale.propTypes = {
  cadenze: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onAddCadenza: PropTypes.func.isRequired,
  onDeleteCadenza: PropTypes.func.isRequired,
};

export default withStyles(styles)(FormAnnuale);
